import css from './index.module.scss';
import { useLang } from '@/i18n';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function Reddit() {
    const { t } = useLang('communitylang.redditSection');
    const { Link } = useGlobal();

    return (
        <div className={`reddit ${css.reddit}`}>
            <div className="reddit-content">
                <p className="reddit-title">{t('title')}</p>
                <p className="reddit-desc">{t('desc')}</p>
                <div className="join-btn">
                    <Link
                        href="https://bit.ly/3Cu520j"
                        ariaLabel={t('join')}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'community_button',
                            list_name: t('title'),
                            button_name: t('join'),
                        }}
                    >
                        <p className="btn-text">{t('join')}</p>
                    </Link>
                </div>
            </div>
            <div className="reddit-img-box">
                <Link
                    href="https://bit.ly/430SN7e"
                    ariaLabel={t('join')}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'community_button',
                        list_name: t('title'),
                        button_name: t('join'),
                    }}
                >
                    <div className="reddit-img">
                        <NextImage src={require('@publicLocal/community/pc/reddit_img.jpg')} />
                    </div>
                </Link>
            </div>
        </div>
    );
}
